import { useEffect, useState } from 'react';

export const useSlowLoading = (isLoading: boolean, delay = 500): boolean => {
  const [isSlowLoading, setIsSlowLoading] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsSlowLoading(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      setIsSlowLoading(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [isLoading, delay]);

  return isSlowLoading;
};
